import React from 'react';
import Link from 'next/link';

export const TitleSectionBtn = ({ btnTxt, bg, href, hrefExt, spacing }) => {
  return (
    <>
      {bg == 'black' ? (
        <div className="container-fluid " style={{ backgroundColor: '#171717' }}>
          <div className="row">
            <div className="text-center py-5">
              {href ? (
                <Link href={href}>
                  <button
                    type="button"
                    className="btn fs-16-18 rounded-0 "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '16px 30px',
                    }}>
                    {btnTxt}
                  </button>
                </Link>
              ) : (
                <a href={hrefExt} target="_blank" rel="noreferrer">
                  <button
                    type="button"
                    className="btn fs-16-18 rounded-0 "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '16px 30px',
                    }}>
                    {btnTxt}
                  </button>
                </a>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="container-fluid " style={{ backgroundColor: 'white' }}>
          <div className="row">
            <div className="text-center  pb-5">
              {href ? (
                <Link href={href}>
                  <button
                    type="button"
                    className="btn fs-16-18 rounded-0 "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '16px 30px',
                    }}>
                    {btnTxt}
                  </button>
                </Link>
              ) : (
                <a href={hrefExt} target="_blank" rel="noreferrer">
                  <button
                    type="button"
                    className="btn fs-16-18 rounded-0 "
                    style={{
                      fontFamily: 'Josefin Sans',
                      color: '#010101',
                      backgroundColor: '#FCBD00',
                      padding: '16px 30px',
                    }}>
                    {btnTxt}
                  </button>
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
